import { useEffect } from 'react';

export function useArrowNavigation({ enabled, onLeft, onRight, leftEnabled, rightEnabled }) {
  useEffect(() => {
    if (!enabled) return undefined;

    const handleKeyDown = e => {
      if (e.key === 'ArrowLeft' && leftEnabled) {
        e.preventDefault();
        onLeft?.(e);
      } else if (e.key === 'ArrowRight' && rightEnabled) {
        e.preventDefault();
        onRight?.(e);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [enabled, onLeft, onRight, leftEnabled, rightEnabled]);
}
